import {
  GetMovieDetailQuery,
  GetMoviesQuery,
} from '@scentregroup/shared/graphql'
import { MovieListItem } from '../components/now-showing'
import { DateTime, getToday } from './date-helpers'

const getSessions = (
  movie:
    | NonNullable<GetMoviesQuery['movies']>[number]
    | NonNullable<GetMovieDetailQuery['movies']>[number],
  timeZone: string
): string[] =>
  (movie.sessions || [])
    .reduce((acc: string[], session) => {
      if (!session?.startTime) {
        return acc
      }
      const dt = DateTime.fromISO(session.startTime, {
        timeZone,
      })

      const dayDiff = DateTime.moment
        .duration(dt.startOf('day').diff(getToday(timeZone)))
        .days()

      if (!acc[dayDiff]) {
        acc[dayDiff] = dt.format('YYYY-MM-DD')
      }

      return acc
    }, [])
    .filter(sessionsOfDay => sessionsOfDay !== null)

const getMoviesWithSessions = (
  movies: GetMoviesQuery['movies'] | GetMovieDetailQuery['movies'],
  timeZone: string
): MovieListItem[] =>
  (movies || []).map(m => ({
    id: m.id,
    title: m.title,
    image: m.imageUrl || '',
    genre: m?.genres?.[0] || '',
    classification: m?.classification?.rating || '',
    sessions: getSessions(m, timeZone),
  }))

export default getMoviesWithSessions
